// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { text } from '../../tokens/themeColors/text';
export var linkColors = function(mode) {
    var tx = text(mode);
    return {
        default: {
            text: tx.link
        },
        disabled: {
            text: tx.disabled
        }
    };
};

//# sourceMappingURL=linkColors.js.map